import { gql } from '@apollo/client'

import {
  METADATA_NODE_FRAGMENT,
  SIMPLE_USER_FRAGMENT,
} from '../../../common/graphql/fragments'

import DISH_ADDITIONAL_INGREDIENT_FRAGMENT from './dish-additional-ingredient-fragment'
import DISH_CHOICE_INGREDIENT_FRAGMENT from './dish-choice-ingredient-fragment'
import DISH_MAIN_INGREDIENT_FRAGMENT from './dish-main-ingredient-fragment'

const DISH_DETAILS_FRAGMENT = gql`
  fragment DishDetailsFragment on Dish {
    id
    autoeatId
    originalDishId
    menuId
    tier
    name
    description
    ingredients
    styledName
    styledDescription
    styledIngredients
    translatedName
    translatedDescription
    translatedIngredients
    lowPrice
    highPrice
    certainty
    dietDescriptors
    allergenDescriptors
    addonDescriptors
    miscDescriptors
    nutritionDescriptors
    qadAt
    qcdAt
    miscAndChoiceUpdatedAt
    dishTypeUpdatedAt
    courseTypeUpdatedAt
    dietsUpdatedAt
    allergensUpdatedAt
    ingredientsUpdatedAt
    isPublishedUpdatedAt
    isPublished
    isDeleted
    isFake
    isTierOneDone
    isCurationDone
    isQaDone
    isQcDone
    isEnabled
    isAiIgnored
    isManualIgnored
    updatedAt
    createdAt
    tierOneDoneAt
    curatedAt
    autoeatUpdatedAt
    lastModifiedByTierOneAt
    lastModifiedByCuratorAt
    lastModifiedByQaAt
    lastModifiedByQcAt
    lastRestSuggestionsAt
    lastPubSubSuggestionsAt
    menuTitle {
      id
      styledTitle
      styledDescription
    }
    dishType {
      ...MetadataNodeFragment
    }
    courseType {
      ...MetadataNodeFragment
    }
    mainIngredients {
      ...DishMainIngredientFragment
    }
    additionalIngredients {
      ...DishAdditionalIngredientFragment
    }
    choiceIngredients {
      ...DishChoiceIngredientFragment
    }
    blacklistedIngredients {
      ingredient {
        id
        name
      }
      word
      originField
      isSuggestedUsingMl
      isSuggestedUsingParser
      mlScore
      matchType
    }
    updatedBy {
      ...SimpleUserFragment
    }
    createdBy {
      ...SimpleUserFragment
    }
    tierOneDoneBy {
      ...SimpleUserFragment
    }
    curatedBy {
      ...SimpleUserFragment
    }
    qadBy {
      ...SimpleUserFragment
    }
    qcdBy {
      ...SimpleUserFragment
    }
    lastModifiedByTierOne {
      ...SimpleUserFragment
    }
    lastModifiedByCurator {
      ...SimpleUserFragment
    }
    lastModifiedByQa {
      ...SimpleUserFragment
    }
    lastModifiedByQc {
      ...SimpleUserFragment
    }
  }
  ${DISH_CHOICE_INGREDIENT_FRAGMENT}
  ${DISH_MAIN_INGREDIENT_FRAGMENT}
  ${DISH_ADDITIONAL_INGREDIENT_FRAGMENT}
  ${SIMPLE_USER_FRAGMENT}
  ${METADATA_NODE_FRAGMENT}
`
export default DISH_DETAILS_FRAGMENT
